import { jsx } from 'react/jsx-runtime';
import { cn } from '../../lib/utils.js';

const ButtonAmount = ({ children, onClick, disabled, className }) => {
  return /* @__PURE__ */ jsx(
    "button",
    {
      onClick,
      disabled,
      className: cn(
        `w-full whitespace-nowrap flex items-center justify-center bg-base-white border border-basic-04 rounded-md eng-body-md h-9 text-basic-02 pt-[1px] 
                [@media(hover:hover){&:hover:not(:active)}]:border-primary-02 [@media(hover:hover){&:hover:not(:active)}]:text-primary-04 
                [@media(hover:hover){&:hover:not(:active)}]:bg-interactive-extra-hovered 
                active:border-primary-02 active:bg-interactive-extra-hovered active:shadow-[inset_0_0_0_1px_var(--color-border-primary-02)]
                disabled:bg-state-disabled-01 disabled:border-state-disabled-02 disabled:text-state-disabled-04 md:h-11`,
        className
      ),
      children
    }
  );
};

export { ButtonAmount };
